export const objectToQueryString = (queryObject = {}) => {
    const queryParams = new URLSearchParams();
    for (const key of Object.keys(queryObject)) {
        queryParams.append(key, `${queryObject[key]}`);
    }
    return queryParams.toString();
};
